<template>
  <div class="ml-3 mr-3">
    <custom-callout
      ref="detail-ref"
      border-color-hex="#B5C3BC"
      class-main="mt-3 rounded"
      :has-toggle="false"      
    >
      <div class="row py-2 mr-md-0 align-items-center">            
        <div class="col-md-10">
          <div class="row mb-3">
            <div class="col-12 col-md-2 my-2">
              <span class="data-title d-block border-mobile"
                >Nombre del Estudiante:</span
              >
              <span class="font-16 color-black">
                {{ data.studentName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2 my-2">
              <span class="data-title d-block border-mobile"
                >SIE:</span
              >
              <span class="font-16 color-black">
                {{ data.studentSieId | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2 my-2">
              <span class="data-title d-block">Estatus:</span>
              <span class="font-16 color-black">
                {{ data.studentStatus | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2 my-2">
              <span class="data-title d-block">Fecha de Nacimiento:</span>
              <span class="font-16 color-black">
                {{ data.birthDate | date | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2 my-2">
              <span class="data-title d-block">Edad:</span>
              <span class="font-16 color-black">
                {{ data.age | empty }}
              </span>
            </div>
             <div class="col-12 col-md-2 my-2">
              <span class="data-title d-block">Impedimento:</span>
              <span class="font-16 color-black">
                {{ data.impediment | empty }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-2 col-lg-2 mt-2 mt-lg-0">
          <div class="text-right">            
              <action-button                  
                  variant="outline-success"                  
                  i="fas fa-file-import fa-fw mr-2"
                  id="autismsurveillancenetworkEnterDetailBtn"
                  @click="goToDetail(data)"
                  text="Entrar"
                />                                                     
          </div>
        </div>
      </div>     
    </custom-callout>   
  </div>     
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import store, { modulesName } from "@/store/index";
import { CustomTab, CustomTabItem } from "custom-tabs";

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    ActionButton,   
    CustomTab,
    CustomTabItem,  
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }, 
  computed: {      
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },   
  },
  methods: {    
    goToDetail(item) {
      
      this.$router.push({
        name: "autismsurveillancenetworkDetail",
        params: { studentSie: item.studentSieId }
      });
    },    
  }
};
</script>

<style lang="scss" scoped>

</style>
